import axios from 'axios';
import {ADMIN_API_URL} from "../api";


export const createAdmin = async (data) => {
    try {
        const response = await axios.post(`${ADMIN_API_URL}`, data);
        return {error: false, payload: response.data};
    } catch (error) {
        return {error: true, payload: error.response?.data?.message || 'Failed to create admin user'};
    }
};

export const getAdminById = async (id) => {
    try {
        const response = await axios.get(`${ADMIN_API_URL}/${id}`);
        return {error: false, payload: response.data};

    } catch (error) {
        return {error: true, payload: error.response?.data?.message || 'Failed to get admin user'};
    }
}

export const updateAdmin = async (data, id) => {
    try {
        const response = await axios.put(`${ADMIN_API_URL}/${id}`, data);
        return {error: false, payload: response.data};
    } catch (error) {
        return {error: true, payload: error.response?.data?.message || 'Failed to update admin user'};
    }
};

export const deleteAdmin = async (id) => {
    try {
        const response = await axios.delete(`${ADMIN_API_URL}/${id}`);
        return {error: false, payload: response.data};
    } catch (error) {
        return {error: true, payload: error.response?.data?.message || 'Failed to delete admin user'};
    }
};
